import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { initFlags, setFlags } from './actions';
import { FlagsObject } from '../types';
import { addCalculatedFlags } from '../helpers';

const actionHandlers = handleActions<FlagsObject, any>(
  {
    [initFlags.toString()]: (state, { payload: { flags } }: ReturnType<typeof initFlags>) =>
      addCalculatedFlags(flags),
    [setFlags.toString()]: (state, { payload: { flags } }: ReturnType<typeof setFlags>) =>
      addCalculatedFlags({
        ...state,
        ...flags,
      }),
  },
  {}
);

export default {
  [reduxKey as string]: actionHandlers,
};
